import {lifecycle, withState} from 'recompose';
import PropType from 'prop-types';
import RecipePage from './recipePage';
import {Container, Recipes, Button} from './styles';

const RecipeList = ({pages, setPages, endReached, setEndReached, categoryId}) => {
  const onEndReached = () => {
    setEndReached(true);
    setPages(pages - 1);
  };
  const recipePages = [];
  for (let page = 1; page <= pages; page++) {
    recipePages.push(
      <RecipePage onEndReached={onEndReached} key={page} page={page} categoryId={categoryId} />,
    );
  }
  return (
    <Container>
      <Recipes>{recipePages.map(recipePage => recipePage)}</Recipes>
      {!endReached && <Button onClick={() => setPages(pages + 1)}>Voir plus de recettes</Button>}
    </Container>
  );
};

RecipeList.propTypes = {
  pages: PropType.number.isRequired,
  setPages: PropType.func.isRequired,
  endReached: PropType.bool.isRequired,
  setEndReached: PropType.func.isRequired,
  categoryId: PropType.number,
};

export default RecipeList
  |> lifecycle({
    componentDidUpdate(prevProps) {
      const {categoryId, setPages, setEndReached} = this.props;
      if (prevProps.categoryId !== categoryId) {
        setPages(1);
        setEndReached(false);
      }
    },
  })
  |> withState('pages', 'setPages', 1)
  |> withState('endReached', 'setEndReached', false);
